import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Careers from "@/pages/Careers";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Dashboard from "@/pages/Dashboard";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Profile from "@/pages/Profile";
import Leadership from "@/pages/Leadership";
import ScrollToTop from "@/components/ScrollToTop";
import { AuthProvider } from "@/context/AuthContext";
import { useEffect } from "react";
import { initMagicAnimations } from "@/lib/magicAnimations";

function AppInner() {
  const location = useLocation();

  useEffect(() => {
    // Re-initialize magic animations on every route change
    // Small delay to ensure DOM is fully updated
    const timer = setTimeout(() => {
      initMagicAnimations();
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <ScrollToTop />
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppInner />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/leadership" element={<Leadership />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
